import { render, staticRenderFns } from "./vaccineDetail.vue?vue&type=template&id=33bf3487&scoped=true"
import script from "./vaccineDetail.vue?vue&type=script&lang=js"
export * from "./vaccineDetail.vue?vue&type=script&lang=js"
import style0 from "./vaccineDetail.vue?vue&type=style&index=0&id=33bf3487&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33bf3487",
  null
  
)

export default component.exports